// Firebase initialisation.
import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDniWn8Ks4KNYAQqG4f-OCY4-WG4VxsGzQ",
  authDomain: "taptap-emdr.firebaseapp.com",
  projectId: "taptap-emdr",
  storageBucket: "taptap-emdr.firebasestorage.app",
  messagingSenderId: "1033569391848",
  appId: "1:1033569391848:web:7a667793e2d72acb62a55d",
  measurementId: "G-K12ZEWXTKK",
};

const app = initializeApp(firebaseConfig);

// Use localStorage-based persistence rather than the default IndexedDB chain:
// IndexedDB can hang inside the iOS WKWebView (capacitor:// scheme), which
// stops onAuthStateChanged from ever firing. localStorage is reliable there,
// with session/in-memory as fallbacks.
export const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence, browserSessionPersistence, inMemoryPersistence],
});

export const db = getFirestore(app);
export const functions = getFunctions(app);

// App Check: proves callable-function requests come from the real app, not a
// script hitting the backend directly. Only skipped if the site key is
// missing (e.g. a local checkout before the key was configured) so a
// misconfigured build fails safe (no App Check header) rather than crashing.
//
// Uses the Enterprise provider, not ReCaptchaV3Provider: the key registered
// in Google's console turned out to be a reCAPTCHA Enterprise key (Google's
// console now funnels most new registrations there even when the type shows
// as "v3" scoring) — ReCaptchaV3Provider only works with a classic-console
// key and fails with a silent 403 against an Enterprise one.
if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export default app;
